<span class="pizza-party">
    Success: Signature(s) save successfully. 🍕
  </span>
  